import { useState, useCallback, useRef } from 'preact/hooks';
export function useWebsterChat() {
    const [messages, setMessages] = useState([]);
    const [generating, setGenerating] = useState(false);
    const messageCounter = useRef(0);
    const addUserMessage = useCallback((content, options) => {
        const msg = {
            id: `user-${++messageCounter.current}`,
            role: 'user',
            content,
            timestamp: new Date(),
            createdByName: options?.createdByName ?? null,
        };
        setMessages(prev => [...prev, msg]);
    }, []);
    const addAssistantMessage = useCallback((content, options) => {
        const msg = {
            id: `assistant-${++messageCounter.current}`,
            role: 'assistant',
            content,
            timestamp: new Date(),
            modelId: options?.modelId ?? null,
            outputTokens: options?.outputTokens ?? null,
        };
        setMessages(prev => [...prev, msg]);
    }, []);
    const updateStreamingMessage = useCallback((id, update) => {
        setMessages(prev => {
            const idx = prev.findIndex(m => m.id === id);
            if (idx >= 0) {
                const updated = [...prev];
                updated[idx] = { ...updated[idx], ...update };
                return updated;
            }
            // Message doesn't exist yet — create it
            return [...prev, {
                    id,
                    role: 'assistant',
                    content: '',
                    timestamp: new Date(),
                    ...update,
                }];
        });
    }, []);
    const finalizeStreamingMessage = useCallback((id) => {
        setMessages(prev => prev.map(m => m.id === id ? { ...m, streamStatus: undefined } : m));
    }, []);
    const removeMessage = useCallback((id) => {
        setMessages(prev => prev.filter(m => m.id !== id));
    }, []);
    const initializeFromHistory = useCallback((msgs) => {
        setMessages(msgs);
    }, []);
    const clear = useCallback(() => {
        setMessages([]);
        setGenerating(false);
    }, []);
    return {
        messages,
        generating,
        hasMessages: messages.length > 0,
        addUserMessage,
        addAssistantMessage,
        updateStreamingMessage,
        finalizeStreamingMessage,
        removeMessage,
        setGenerating,
        initializeFromHistory,
        clear,
    };
}
